export const portTypes = ["Airport", "Seaport"];
